import { Container } from 'react-bootstrap';
import { useFetch } from '../../hooks/useFetch';
import { useDocumentMeta } from '../../hooks/useDocumentMeta';
import { fetchMySupportersService } from '../../services/panelService';
import '../admin/admin.css';

const fecha = (valor) =>
    valor ? new Date(valor.replace(' ', 'T')).toLocaleDateString() : '—';

/**
 * Clientes que le han dado tokens a la modelo.
 *
 * El dato se agrupa en el servidor sobre el libro mayor de tokens. Antes ni
 * siquiera se podía calcular: la transferencia solo dejaba el nombre del
 * remitente dentro de un texto libre, sin un id al que agarrarse.
 */
export default function MySupporters() {
    useDocumentMeta({ title: 'Quién me da tokens', noIndex: true });

    const { data: supporters, error, loading } = useFetch(fetchMySupportersService, {
        params: { per_page: 30 },
    });

    const total = supporters?.reduce((suma, fila) => suma + fila.total, 0) ?? 0;

    return (
        <div className="admin-container">
            <Container fluid>
                <div className="admin-header">
                    <div>
                        <h2 className="admin-title">Quién me da tokens</h2>
                        <p className="text-muted small mb-0">
                            {supporters?.length
                                ? `${supporters.length} ${supporters.length === 1 ? 'persona' : 'personas'} · ${total} tokens recibidos`
                                : 'Tus apoyos aparecerán aquí'}
                        </p>
                    </div>
                </div>

                {error && <div className="alert alert-danger">{error}</div>}

                {loading && !supporters && (
                    <p className="text-muted text-center py-5">Cargando...</p>
                )}

                {supporters?.length === 0 && !loading && (
                    <div className="table-empty">
                        <i className="fa-solid fa-hand-holding-dollar" aria-hidden="true"></i>
                        <p>
                            Todavía no has recibido tokens. Los apoyos que te lleguen desde tu
                            sala se irán sumando aquí.
                        </p>
                    </div>
                )}

                {supporters?.length > 0 && (
                    <div className="custom-table-container">
                        <table className="table table-striped table-bordered table-hover custom-table text-center">
                            <thead>
                                <tr>
                                    <th>Cliente</th>
                                    <th>Tokens</th>
                                    <th>Propinas</th>
                                    <th>Última</th>
                                </tr>
                            </thead>
                            <tbody>
                                {supporters.map((fila) => (
                                    <tr key={fila.user_id}>
                                        <td data-label="Cliente" className="fw-bold text-white">{fila.name}</td>
                                        <td data-label="Tokens">
                                            <span className="supporter-total">
                                                <i className="fa-solid fa-coins" aria-hidden="true"></i> {fila.total}
                                            </span>
                                        </td>
                                        <td data-label="Propinas" className="text-muted">{fila.tips}</td>
                                        <td data-label="Última" className="text-muted">{fecha(fila.last_tip)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </Container>
        </div>
    );
}
